import axios from "axios";
import {
    USER_LOADED,
    LOGOUT_SUCCESS,
    SAVE_TOKEN,
    IS_VALID_KEY,
    VALID_USER
} from "../constants/action-types";
import { isValidLicense } from "./actionPerform";
import { loadingOff } from "../utils";
import { errorMsg } from "../errorMsg/ErrorMsg";

const port = 'http://192.168.1.128:8081'
// const port = "http://192.168.3.41:8081"
// const port = "http://192.168.2.132:8081"
// const port = "http://192.168.2.103:8081"
// const port = 'http://veras-chevron.sigmastream.com:8081'
// const port = "getState().data.apiUrl.address"
// ${getState().data.apiUrl.address}

export const uiLogin = ({ user, password }) => (dispatch, getState) => {
    if(user !== "" && password !== "") {
        axios
        .get(`${getState().data.apiUrl.address}/veras/user/login`, {params: {username:user, password:password}})
        .then((res) => {
            dispatch(loadingOff())

            const header = res.data.Message;
            sessionStorage.setItem('header',header)
            if(res.data instanceof String ? !isValidLicense(res.data) : true) {
                if(res.data.Error !== undefined) {
                    errorMsg(res.data.Error, "Login Page");
                } else {
                    sessionStorage.setItem('header', res.data.Message)
                    dispatch({
                        type: SAVE_TOKEN,
                        payload: user,
                    });
                    dispatch({
                        type: USER_LOADED,
                        payload: {username:user, password:password },
                    });
                    dispatch({
                        type: VALID_USER,
                        payload: true
                    })
                    document.location.replace("/veras/#/");
                }
                } else {
                    errorMsg("Invalid License Key!!", "Login Page")
                    document.location.replace("/veras/#/validForm");
                    dispatch({
                        type: IS_VALID_KEY,
                        payload: false
                    })
                }}).catch((err) => {
                    dispatch(loadingOff())
                    errorMsg("Login failed. Please check credentials.", "Login Page");
                });
            
        }
};

export const uiLogout = () => (dispatch, getState) => {
    dispatch({
        type: LOGOUT_SUCCESS
    });
    dispatch(loadingOff())
    document.location.replace("/veras/#/login");
    sessionStorage.setItem("activeTab",0)
    sessionStorage.removeItem("activePageSize");
    sessionStorage.removeItem("finishPageSize");
    sessionStorage.removeItem("auditPageSize");
    sessionStorage.removeItem("rolePerPageSize");
    sessionStorage.removeItem("addUserPageSize");
    sessionStorage.removeItem("addRolePageSize");
    sessionStorage.removeItem("appPropPageSize");
    sessionStorage.removeItem("dpPageSize");
    sessionStorage.removeItem("nodePageSize");
    sessionStorage.removeItem("aspectPageSize");
    sessionStorage.removeItem("dataViewerPageSize");
    sessionStorage.removeItem("syncPageSize");
};